import { Button } from '@occc-app/design-system';
import { Flow_Types } from '@occc-app/offerHelpers/types';

type CampaignComponentFooterActionsProps = {
  currentFlowType: Flow_Types;
  isSubmitDisabled: boolean;
  onCancel?: () => void;
};

export const CampaignComponentFooterActions = ({
  currentFlowType,
  onCancel,
  isSubmitDisabled,
}: CampaignComponentFooterActionsProps) => {
  return (
    <>
      {onCancel ? <Button onClick={onCancel}>Cancel</Button> : null}
      <Button type='submit' color='primary' variant='contained' disabled={isSubmitDisabled}>
        {currentFlowType === Flow_Types.Configure ? 'Continue' : 'Save'}
      </Button>
    </>
  );
};
